enum LocalStorageKey {
	HitomiAction = 'hitomi-action',
	HitomiRedirect = 'hitomi-redirect',
	DocumentViewMode = 'document-view-mode',
	DocumentActionMode = 'document-action-mode',
	DoujinAction = 'doujin-action',
	ImageLoading = 'image-loading',
	DoujinRedirect = 'doujin-redirect',
	JAVAction = 'jav-action',
	JAVRedirect = 'jav-redirect',
	HentaiAction = 'hentai-action',
	HentaiRedirect = 'hentai-redirect'
}

export default LocalStorageKey;
